export default "__VITE_ASSET__2e3f41e7__"